/**
 * Dependency edges between learning steps.
 * Each tuple is [prerequisiteId, dependentId].
 * A step should ideally be completed before its dependents.
 */
export const EDGES: ReadonlyArray<readonly [number, number]> = [
  [1, 2],
  [1, 3],
  [1, 5],
  [2, 4],
  [2, 5],
  [3, 5],
  [3, 6],
  [4, 5],
  [4, 14],
  [5, 6],
  [5, 7],
  [5, 8],
  [6, 7],
  [6, 31],
  [7, 8],
  [8, 9],
  [8, 10],
  [8, 11],
  [8, 13],
  [9, 10],
  [9, 12],
  [11, 12],
  [12, 10],
  [13, 30],
  [13, 32],
  [13, 33],
  [10, 14],
  [14, 15],
  [14, 17],
  [15, 16],
  [15, 18],
  [15, 25],
  [16, 19],
  [16, 20],
  [16, 21],
  [17, 22],
  [18, 21],
  [19, 21],
  [19, 27],
  [20, 21],
  [22, 23],
  [22, 24],
  [22, 25],
  [23, 24],
  [23, 26],
  [24, 27],
  [25, 26],
  [25, 28],
  [26, 27],
  [26, 30],
  [26, 31],
  [27, 49],
  [28, 47],
  [28, 32],
  [29, 27],
  [30, 32],
  [30, 36],
  [30, 47],
  [31, 33],
  [31, 34],
  [31, 36],
  [32, 35],
  [32, 36],
  [33, 35],
  [33, 37],
  [34, 43],
  [34, 44],
  [35, 37],
  [35, 48],
  [36, 49],
  [36, 50],
  [37, 50],
  [15, 38],
  [18, 38],
  [21, 38],
  [38, 41],
  [38, 42],
  [39, 40],
  [39, 41],
  [15, 39],
  [40, 41],
  [41, 43],
  [41, 44],
  [43, 45],
  [44, 49],
  [42, 45],
  [45, 46],
  [45, 47],
  [46, 48],
  [47, 48],
  [48, 50],
  [49, 50],
] as const;
